import { SimilarKeywordAreaType } from 'components/JobCard';
import { FC } from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';

/**
 * SimilarKeywordAreaコンポーネントのプロパティ
 */
interface Props {
  // 類似キーワードエリアのデータ
  similarKeywordArea: SimilarKeywordAreaType;
}

/**
 * SimilarKeywordAreaコンポーネント
 * 類似キーワードを表示するコンポーネント
 * @param {Props} props - コンポーネントのプロパティ
 * @returns {JSX.Element | null} SimilarKeywordAreaのJSX要素、類似キーワードがない場合はnull
 */
export const SimilarKeywordArea: FC<Props> = ({ similarKeywordArea }) => {
  const { searchKeywords, similarKeywordList } = similarKeywordArea;

  if (!similarKeywordList?.length) {
    // 類似キーワードが取得できなかった場合は非表示
    return null;
  }

  return (
    <p className={styles.similarKeywordArea}>
      この求人のキーワード：
      {similarKeywordList.map((keyword, i) => {
        const isBold = searchKeywords?.includes(keyword);

        return (
          <span key={i}>
            <span
              className={classNames({
                [styles['similarKeywordArea__text-bold']]: isBold,
              })}
            >
              {keyword}
            </span>
            {similarKeywordList.length - 1 !== i && '、'}
          </span>
        );
      })}
    </p>
  );
};
